import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { map } from 'rxjs/operators';
import { Zone } from 'src/app/vehicles/model/zone';
import { ZoneService } from 'src/app/vehicles/service/zone.service';

@Component({
  selector: 'app-stp-zone-selector',
  templateUrl: './stp-zone-selector.component.html',
  styleUrls: ['./stp-zone-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StpZoneSelectorComponent),
      multi: true
    }
  ]
})
export class StpZoneSelectorComponent implements OnInit {
  @Input() type: 'id' | 'name' = 'id';
  @Input() multiple: boolean = false;

  availableZones: AvaliableZone[] = [];
  value: string | number | string[] | number[] | null = null;
  disabled: boolean = false;

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(private zoneService: ZoneService) { }


  ngOnInit(): void {
    this.zoneService.fetchZones()
      .pipe(
        map(zones => zones.map(z => new AvaliableZone(z.name, this.getOptionValue(z))))
      )
      .subscribe(s => {
        this.availableZones = s;
      });
  }


  getOptionValue(item: Zone): any {
    return this.type ? item[this.type] : item;
  }

  writeValue(value: string | number | string[] | number[] | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectChange(value: string | number | string[] | number[] | null): void {
    this.value = value;
    this.onChange(value);
  }

}

class AvaliableZone {
  constructor(
    public readonly displayValue: string,
    public readonly value: number | string,
  ) { }
}

